export const DEFAULT_SEARCH_PRODUCTS_NEXT_TOKEN = "1";
